/* =============================================================
   RENOBAT — JS externalisé des sections Custom Liquid
   Fichier à uploader dans Shopify > Thèmes > Modifier le code > Assets
   ============================================================= */

/* =============================================================
   CARROUSEL AVIS CLIENTS
   ============================================================= */
(function(){
  function initCarousel(){
    var avisData=[
      {name:"Raymonde P.",initials:"RP",text:"Je suis tout \u00e0 fait satisfaite des travaux r\u00e9alis\u00e9s. L\u2019\u00e9quipe a \u00e9t\u00e9 professionnelle du d\u00e9but \u00e0 la fin. Merci \u00e0 Renobat !",project:"Travaux de r\u00e9novation",location:"Paris 17"},
      {name:"Mirka K.",initials:"MK",text:"Salim est arriv\u00e9 \u00e0 l\u2019heure pour l\u2019inspection de l\u2019appartement. Intervention men\u00e9e avec professionnalisme : clair, pr\u00e9cis et aidant. La visite a \u00e9t\u00e9 efficace. Je recommande en toute confiance.",project:"Inspection & devis appartement",location:"Puteaux"},
      {name:"Philippe A.",initials:"PA",text:"La pose et le raccordement d\u2019un piquet de terre effectu\u00e9s par Alexandre avec soin et dans les d\u00e9lais, dans le respect des lieux. Le devis incluait toutes les prestations. Merci \u00e0 Alexandre !",project:"Raccordement \u00e9lectrique",location:"Joinville-le-Pont"},
      {name:"Fr\u00e9d\u00e9ric L.",initials:"FL",text:"R\u00e9novation de l\u2019installation \u00e9lectrique. Intervention rapide et efficace par Alexandre et S\u00e9bastien. Mention sp\u00e9ciale \u00e0 Sacha, \u00e0 l\u2019\u00e9coute du client. Qualit\u00e9 et confiance ont un prix\u2026 \ud83d\ude09",project:"R\u00e9novation \u00e9lectrique",location:"Rueil-Malmaison"},
      {name:"Cl\u00e9mentine O.",initials:"CO",text:"J\u2019ai fait appel \u00e0 Renobat pour remplacer mon volet \u00e9lectrique. Tr\u00e8s bonne exp\u00e9rience \u2014 Salim a \u00e9t\u00e9 tr\u00e8s pro et tr\u00e8s aimable, et le poseur \u00e9galement. Je les recommande !",project:"Remplacement volet \u00e9lectrique",location:"Paris 14"},
      {name:"Guy B.",initials:"GB",text:"Je suis content du travail r\u00e9alis\u00e9. Travaux de peinture et d\u2019\u00e9lectricit\u00e9 tr\u00e8s bien faits, tout a \u00e9t\u00e9 nettoy\u00e9 avant de partir. Tr\u00e8s satisfait !",project:"Peinture & \u00e9lectricit\u00e9",location:"Paris 12"},
      {name:"Nathalie D.",initials:"ND",text:"R\u00e9novation compl\u00e8te de notre salle de bain. L\u2019\u00e9quipe a su s\u2019adapter aux contraintes de la copropri\u00e9t\u00e9. Douche italienne magnifique, carrelage pos\u00e9 avec soin. Je recommande !",project:"R\u00e9novation salle de bain",location:"Courbevoie"},
      {name:"Thomas M.",initials:"TM",text:"Rafra\u00eechissement complet de mon appartement : peinture, parquet et reprises \u00e9lectriques. Travail soign\u00e9, \u00e9quipe ponctuelle et chantier toujours propre. Tr\u00e8s pro.",project:"Rafra\u00eechissement appartement",location:"Suresnes"},
      {name:"Isabelle R.",initials:"IR",text:"Renobat a refait toute l\u2019\u00e9lectricit\u00e9 de notre maison aux normes. Alexandre a pris le temps de tout nous expliquer. Travail propre et soign\u00e9. Merci !",project:"Mise aux normes \u00e9lectriques",location:"Nanterre"},
      {name:"Laurent G.",initials:"LG",text:"Pose de parquet et peinture dans tout l\u2019appartement. \u00c9quipe \u00e0 l\u2019heure chaque jour, chantier propre en fin de journ\u00e9e. Excellent rapport qualit\u00e9-prix.",project:"Parquet & peinture",location:"Levallois-Perret"},
      {name:"Caroline V.",initials:"CV",text:"R\u00e9novation de notre cuisine confi\u00e9e \u00e0 Renobat. Du devis \u00e0 la livraison, tout a \u00e9t\u00e9 fluide. Sacha nous a bien accompagn\u00e9s pour les mat\u00e9riaux. R\u00e9sultat superbe !",project:"R\u00e9novation cuisine",location:"Boulogne-Billancourt"},
      {name:"Jean-Pierre S.",initials:"JS",text:"Plomberie et carrelage pour notre salle d\u2019eau. \u00c9quipe s\u00e9rieuse, respect des d\u00e9lais et suivi r\u00e9gulier tout au long du chantier. Rien \u00e0 redire, merci Renobat.",project:"Plomberie & carrelage",location:"Puteaux"}
    ];

    var starSVG='<svg class="renobat-avis-home-card-star" fill="currentColor" viewBox="0 0 20 20"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/></svg>';
    var fiveStars=starSVG+starSVG+starSVG+starSVG+starSVG;
    var pinSVG='<svg fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clip-rule="evenodd"/></svg>';
    var colors=['renobat-avis-home-card--1','renobat-avis-home-card--2','renobat-avis-home-card--3'];
    var grid=document.getElementById('renobatAvisGrid');
    if(!grid) return;

    var perPage=window.innerWidth>900?3:1;
    var totalPages=Math.ceil(avisData.length/perPage);
    var current=0,timer,DELAY=7000,busy=false;

    function cardHTML(a,idx){
      return '<div class="renobat-avis-home-card '+colors[idx%3]+'"><span class="renobat-avis-home-card-quote">\u201C</span><div class="renobat-avis-home-card-stars">'+fiveStars+'</div><p class="renobat-avis-home-card-text">'+a.text+'</p><div class="renobat-avis-home-card-author"><div class="renobat-avis-home-card-avatar">'+a.initials+'</div><div class="renobat-avis-home-card-info"><div class="renobat-avis-home-card-name">'+a.name+'</div><div class="renobat-avis-home-card-project">'+a.project+'</div><div class="renobat-avis-home-card-location">'+pinSVG+' '+a.location+'</div></div></div></div>';
    }

    var pagesHTML=[];
    for(var p=0;p<totalPages;p++){
      var s=p*perPage, html='';
      for(var i=s;i<Math.min(s+perPage,avisData.length);i++){
        html+=cardHTML(avisData[i],i-s);
      }
      pagesHTML.push(html);
    }

    function render(page){
      grid.innerHTML=pagesHTML[page];
    }

    function go(page){
      if(busy) return;
      busy=true;
      grid.classList.add('fade-out');
      setTimeout(function(){
        requestAnimationFrame(function(){
          current=page;
          render(current);
          grid.offsetHeight;
          grid.classList.remove('fade-out');
          setTimeout(function(){ busy=false; }, 420);
        });
      }, 420);
    }

    function next(){ go((current+1)%totalPages); }
    function start(){ timer=setInterval(next,DELAY); }
    function stop(){ clearInterval(timer); }
    start();

    grid.addEventListener('mouseenter',stop);
    grid.addEventListener('mouseleave',start);

    var tx=0;
    grid.addEventListener('touchstart',function(e){
      tx=e.changedTouches[0].screenX; stop();
    },{passive:true});
    grid.addEventListener('touchend',function(e){
      var d=tx-e.changedTouches[0].screenX;
      if(d>50) next();
      else if(d<-50) go((current-1+totalPages)%totalPages);
      start();
    },{passive:true});

    var resizeTimer;
    window.addEventListener('resize',function(){
      clearTimeout(resizeTimer);
      resizeTimer=setTimeout(function(){
        var np=window.innerWidth>900?3:1;
        if(np!==perPage){
          perPage=np;
          totalPages=Math.ceil(avisData.length/perPage);
          pagesHTML=[];
          for(var p=0;p<totalPages;p++){
            var s=p*perPage, html='';
            for(var i=s;i<Math.min(s+perPage,avisData.length);i++){
              html+=cardHTML(avisData[i],i-s);
            }
            pagesHTML.push(html);
          }
          current=0;
          render(0);
        }
      },250);
    });
  }

  if('requestIdleCallback' in window){
    requestIdleCallback(initCarousel,{timeout:3000});
  } else {
    setTimeout(initCarousel,1500);
  }
})();


/* =============================================================
   FAQ ACCORDÉON
   ============================================================= */
(function() {
  var list = document.querySelector('.renobat-faq-home-list');
  if (!list) return;

  list.addEventListener('click', function(e) {
    var button = e.target.closest('.renobat-faq-home-question');
    if (!button) return;

    var item = button.parentElement;
    var wasActive = item.classList.contains('active');

    var current = list.querySelector('.renobat-faq-home-item.active');
    if (current) {
      current.classList.remove('active');
      current.querySelector('.renobat-faq-home-question').setAttribute('aria-expanded', 'false');
    }

    if (!wasActive) {
      item.classList.add('active');
      button.setAttribute('aria-expanded', 'true');
    }
  });
})();


/* =============================================================
   LAZY-LOAD CARTE GOOGLE MAPS
   ============================================================= */
(function() {
  var container = document.getElementById('renobatMapContainer');
  if (!container) return;

  var mapObserver = new IntersectionObserver(function(entries) {
    if (entries[0].isIntersecting) {
      var iframe = document.createElement('iframe');
      iframe.src = container.dataset.src;
      iframe.allowFullscreen = true;
      iframe.loading = 'lazy';
      iframe.referrerPolicy = 'no-referrer-when-downgrade';
      iframe.title = 'Renobat - 130 rue de Normandie, 92400 Courbevoie';
      container.appendChild(iframe);

      var placeholder = document.getElementById('renobatMapPlaceholder');
      if (placeholder) {
        iframe.addEventListener('load', function() {
          placeholder.remove();
        });
      }

      mapObserver.disconnect();
    }
  }, {
    rootMargin: '300px'
  });

  mapObserver.observe(container);
})();